"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _MobileNavItem = _interopRequireDefault(require("../MobileNavItem"));

var _MobileMoreButton = _interopRequireDefault(require("../MobileMoreButton"));

var _index = require("./index.styles"); // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var MobileNavMenu = function MobileNavMenu(_ref) {
  var ariaLabel = _ref.ariaLabel,
      LinkComponent = _ref.LinkComponent,
      items = _ref.items,
      hasMoreItems = _ref.hasMoreItems,
      onClick = _ref.onClick,
      isMoreActive = _ref.isMoreActive,
      mobileMoreText = _ref.mobileMoreText;
  return /*#__PURE__*/_react["default"].createElement(_index.MobileNavWrapper, {
    role: "navigation",
    "aria-label": ariaLabel
  }, items.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_MobileNavItem["default"], (0, _extends2["default"])({
      key: item.name,
      to: item.to,
      LinkComponent: LinkComponent
    }, item));
  }), hasMoreItems ? /*#__PURE__*/_react["default"].createElement(_MobileMoreButton["default"], {
    onClick: onClick,
    className: isMoreActive && 'active',
    mobileMoreText: mobileMoreText
  }) : null);
};

MobileNavMenu.propTypes = {
  ariaLabel: _propTypes.string,
  LinkComponent: _propTypes.elementType.isRequired,
  items: _propTypes.array.isRequired,
  hasMoreItems: _propTypes.bool.isRequired,
  onClick: _propTypes.func.isRequired,
  isMoreActive: _propTypes.bool.isRequired,
  mobileMoreText: _propTypes.string.isRequired
};
var _default = MobileNavMenu;
exports["default"] = _default;